import React from 'react'
import { useSelector } from 'react-redux'

import { getResponse } from '../store/selectors'

const RegisterSuccess = () => {
  const { email, username } = useSelector(getResponse)

  return (
    <div className='qa-register-success-section'>
      <p>Ihre Registrierung war erfolgreich.</p>
      <p>
        Sie erhalten in den nächsten Minuten eine E-Mail mit einem Bestätigungslink an die Adresse
        {' '}{email}. Bitte benutzen Sie diesen Link, um Ihren Account zu aktivieren.
      </p>
      <p>
        Falls Sie die E-Mail mit dem Bestätigungslink nicht erhalten haben, klicken Sie bitte
        {' '}
        <a href={`/account/${username}/activate/resend/`} target='_blank' rel='noopener noreferrer'>hier</a>,
        um die E-Mail erneut zu versenden.
      </p>
    </div>
  )
}

export default RegisterSuccess
